module.exports = __webpack_public_path__ + "img/charger-speeds-mobile@2x.87e0964e.webp";